import { ColDef, ColGroupDef } from "ag-grid-community";
import SearchGridSchema from "@/interfaces/SearchGridSchema";

import {
  createRiskColumnDefs,
  formatScoreValue,
  formatPrivateLabel,
  headerClassFromStatusField,
  createScorePillParamsFromStatus,
} from "./Helpers";
import PillCellRenderer from "./Pill";

export const SupplyChainColumnDefinitions: (
  | ColDef<SearchGridSchema>
  | ColGroupDef<SearchGridSchema>
)[] = [
    {
      field: "countryRegion",
      headerName: "Selling\nCountry/\n Region",
      minWidth: 150,
    },
    {
      field: "deptNumber",
      headerName: "Dept",
      minWidth: 100,
      filter: "agNumberColumnFilter",
    },
    {
      field: "deptName",
      headerName: "Department Name",
      minWidth: 140,
      initialHide: true,
      filter: true,
    },
    {
      field: "vendorNumber",
      headerName: "Vendor #",
      filter: "agNumberColumnFilter",
      minWidth: 120,
    },
    {
      field: "vendorNameEnglish",
      headerName: "Vendor Name\n(English)",
      minWidth: 150,
      filter: true,
    },
    {
      field: "vendorNameNative",
      headerName: "Vendor Name\n(Native)",
      initialHide: true,
      minWidth: 150,
      filter: true,
    },
    {
      field: "privateLabel",
      headerName: "Private\nLabel",
      minWidth: 150,
      filter: true,
      valueFormatter: formatPrivateLabel,
    },
    {
      field: "category1Description",
      headerName: "Category\nDescription",
      initialHide: true,
      filter: true,
      minWidth: 200,
    },
    {
      field: "category12Description",
      headerName: "Category12\nDescription",
      initialHide: true,
      filter: true,
      minWidth: 200,
    },
    {
      field: "category123Description",
      headerName: "Category123\nDescription",
      initialHide: true,
      filter: true,
      minWidth: 200,
    },
    {
      field: "itemNumber",
      headerName: "Item #",
      filter: "agNumberColumnFilter",
      minWidth: 120,
    },
    {
      field: "itemDescription",
      headerName: "Item\nDescription",
      filter: true,
      minWidth: 150,
    },
    {
      field: "itemDescription2",
      headerName: "Item\nDescription2",
      initialHide: true,
      filter: true,
      minWidth: 150,
    },
    {
      field: "commodity",
      headerName: "Commodity",
      minWidth: 150,
    },
    // Inject risk-related columns from helper factory
    ...createRiskColumnDefs(),
    {
      field: "transparencyScore",
      headerName: "Transparency\nScore",
      minWidth: 180,
      filter: "agNumberColumnFilter",
      filterParams: {
        defaultOption: "inRange",
      },
      cellRenderer: PillCellRenderer,
      cellRendererParams: createScorePillParamsFromStatus(
        "transparencyRiskStatus",
      ),
      valueFormatter: formatScoreValue,
      headerClass: headerClassFromStatusField("transparencyRiskStatus"),
    },
    {
      field: "environmentalRiskScore",
      headerName: "Environmental\nScore",
      minWidth: 160,
      filter: "agNumberColumnFilter",
      filterParams: {
        defaultOption: "inRange",
      },
      cellRenderer: PillCellRenderer,
      cellRendererParams: createScorePillParamsFromStatus(
        "environmentalRiskStatus",
      ),
      valueFormatter: formatScoreValue,
      headerClass: headerClassFromStatusField("environmentalRiskStatus"),
    },
    {
      field: "humanRightsRiskScore",
      headerName: "Human Rights\nScore",
      minWidth: 150,
      filter: "agNumberColumnFilter",
      filterParams: {
        defaultOption: "inRange",
      },
      cellRenderer: PillCellRenderer,
      cellRendererParams: createScorePillParamsFromStatus(
        "humanRightsRiskStatus",
      ),
      valueFormatter: formatScoreValue,
      headerClass: headerClassFromStatusField("humanRightsRiskStatus"),
    },
    {
      field: "scmIDNum",
      headerName: "SCM ID",
      minWidth: 120,
      filter: "agNumberColumnFilter",
      filterParams: {
        defaultOption: "inRange",
      },
    },
  ];
